import React, { useEffect, useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { Dialog, DialogContent } from "@mui/material";
import axios from "axios";
import { isEmpty } from "lodash";
import { useGoogleLogin } from "@react-oauth/google";
import { PulseLoader } from "react-spinners";
import { connect } from "react-redux";

import { getBaseURL } from "../../utils";
import CloseEye from "../../icons/CloseEye";
import OpenEye from "../../icons/OpenEye";
import GoogleIcon from "../../icons/GoogleIcon";
import { updateConfigs } from "../../store/actions/action";
import { store } from "../../store";
import { useLoginModal } from "../../Context/LoginModalContext";

const Register = ({ configs, updateConfigs, carts }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const push = useNavigate();
  const { loginModal, closeLoginModal } = useLoginModal();

  const [value, setValue] = useState({
    first_name: "",
    last_name: "",
    email: "",
    new_password: "",
    confirm_password: "",
    gender: "",
    dob: null,
    remember: false,
  });
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState({
    sent: false,
    mobile_otp: "",
    email_otp: "",
    timer: 60,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showRe, setShowRe] = useState(true);

  const toggleShowPassword = () => setShowPassword((s) => !s);

  const otpTimerRef = useRef(null);

  useEffect(() => {
    if (otp.timer === 0) clearInterval(otpTimerRef.current);
    return () => {
      if (otpTimerRef.current) clearInterval(otpTimerRef.current);
    };
  }, [otp.timer]);

  const validateDateOfBirth = (dob) => {
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
    return age >= 18;
  };

  const changeHandler = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
  };

  const otpChangeHandler = (e) => {
    setOtp((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const [validator] = React.useState(
    new SimpleReactValidator({
      className: "gpr-error",
      validators: {
        strongPassword: {
          message:
            "The :attribute must be 8+ characters, include digits (0-9), letters (a-z, A-Z), and special characters (!@#$)",
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(
              val,
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
            );
          },
          messageReplace: (message) => message,
          required: true,
        },
      },
    })
  );

  const submitForm = async (e) => {
    e.preventDefault();

    if (!value?.dob) {
      validator.showMessageFor("dob");
      toast.error("Please select your date of birth.");
      setValue({ ...value });
      return;
    }
    if (!validateDateOfBirth(value.dob)) {
      validator.showMessageFor("dob");
      toast.error("You must be at least 18 years old to register.");
      setValue({ ...value });
      return;
    }

    if (validator.allValid()) {
      let registerData = {
        fullname: `${value.first_name} ${value.last_name}`,
        email: value.email,
        password: value.new_password,
        dateOfBirth: value.dob,
        gender: value.gender,
      };
      setLoading(true);
      await axios
        .post(`${getBaseURL()}v1/auth/register`, { ...registerData })
        .then(async () => {
          validator.hideMessages();
          setOtp((prev) => ({ ...prev, sent: true, email_otp: "" }));
          otpTimerRef.current = setInterval(() => {
            setOtp((prev) => ({ ...prev, timer: prev.timer - 1 }));
          }, 1000);
          toast.success("OTP Sent Successfully");
          setLoading(false);
        })
        .catch((err) => {
          toast.error(err.response?.data?.message);
          setOtp((prev) => ({ ...prev, sent: false }));
          setLoading(false);
        });
    } else {
      validator.showMessages();
      setValue({ ...value });
      let errors = Object.keys(validator.errorMessages);
      for (let i = 0; i < errors.length; i++) {
        if (validator.errorMessages[errors[i]]) {
          toast.error(validator.errorMessages[errors[i]]);
          return;
        }
      }
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    let otpData = { email: value.email, email_otp: otp.email_otp };
    if (otp.email_otp) {
      setLoading(true);
      await axios
        .post(`${getBaseURL()}v1/auth/verifyregisterotp`, { ...otpData })
        .then((res) => {
          toast.success(res.data.message);
          updateConfigs({
            isAuth: true,
            token: res.data.token,
            ...res.data.userdetails,
          });
          navigate("/");
          setLoading(false);
        })
        .catch((err) => {
          toast.error(err.response?.data?.message);
          setLoading(false);
        });
    } else {
      setOtp({ ...otp });
      toast.error("Input cannot be Empty");
      validator.showMessages();
    }
  };

  const resendOtp = async () => {
    await axios
      .post(`${getBaseURL()}v1/auth/resendregisterotp`, {
        email: value.email,
        mobileno: value.phone,
        countrycode: value?.countrycode?.includes("+") ? value?.countrycode : `+${value?.countrycode}`,
      })
      .then(() => toast.success("OTP resent successfully!"))
      .catch((err) => toast.error(err.response?.data?.message));
  };

  const handelAddToCart = async (token) => {
    const data = carts?.map((el) => ({ productid: el?.id, quantity: el?.qty }));
    await axios
      .post(
        "add-cart",
        { products: data },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .catch(() => {});
  };

  const handleGoogleLogin = async (userInfo) => {
    setLoading(true);
    await axios
      .post(`register-oauth-google`, { token: { data: userInfo } })
      .then(async (res) => {
        if (!isEmpty(carts)) await handelAddToCart(res.data.token);
        store.dispatch(
          updateConfigs({
            isAuth: true,
            token: res.data.token,
            ...res.data.userdetails,
          })
        );
        setLoading(false);
        toast.success("Registered successfully.");
        if (location?.state?.pathname) push(location?.state?.pathname);
        else if (location.pathname === "/login") push("/");
        setShowRe(false);
        navigate("/");
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      try {
        const userInfo = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          { headers: { Authorization: `Bearer ${access_token}` } }
        );
        if (userInfo?.status === 200) handleGoogleLogin(userInfo.data);
      } catch {
        toast.error("Couldn't fetch Google profile.");
      }
    },
    onError: () => toast.error("Google sign-up failed."),
  });

  const closeModal = () => navigate("/");

  return (
    <Dialog
      open={showRe}
      onClose={closeModal}
      className="gpr-modal"
      maxWidth="xs"
      fullWidth
      scroll="body"
      PaperProps={{
        style: {
          background: "transparent",
          boxShadow: "none",
          overflow: "visible",
          margin: 16,
        },
      }}
    >
      <DialogContent>
        <div className="gpr-card">
          <button
            type="button"
            className="gpr-close"
            onClick={closeModal}
            disabled={loading}
            aria-label="Close"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>

          {otp.sent ? (
            <>
              <div className="gpr-head">
                <div className="gpr-eyebrow">
                  <span className="gpr-eyebrow-dot" />
                  VERIFY EMAIL
                </div>
                <h2 className="gpr-title">
                  Confirm your <span className="gpr-title-accent">email</span>
                </h2>
                <p className="gpr-sub">
                  We sent a one-time code to <strong>{value.email}</strong>. Enter it below to activate your account.
                </p>
              </div>

              <form className="gpr-form" onSubmit={verifyOtp} noValidate>
                <div className="gpr-field">
                  <label htmlFor="gpr-otp">Email OTP</label>
                  <div className="gpr-input-wrap">
                    <span className="gpr-input-icon">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </span>
                    <input
                      id="gpr-otp"
                      type="text"
                      inputMode="numeric"
                      autoComplete="one-time-code"
                      value={otp.email_otp}
                      name="email_otp"
                      onChange={otpChangeHandler}
                      disabled={loading}
                      placeholder="Enter the 6-digit code"
                    />
                  </div>
                  {validator.message("email_otp", otp.email_otp, "required")}
                </div>

                <button type="submit" className="gpr-submit" disabled={loading}>
                  {loading ? (
                    <PulseLoader size={8} color={"#0b0b0c"} />
                  ) : (
                    <>
                      Verify
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </>
                  )}
                </button>
              </form>

              <div className="gpr-foot">
                Didn't receive a code?{" "}
                <button
                  type="button"
                  className="gpr-link-strong gpr-resend"
                  onClick={resendOtp}
                  disabled={loading}
                >
                  Resend
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="gpr-head">
                <div className="gpr-eyebrow">
                  <span className="gpr-eyebrow-dot" />
                  CREATE ACCOUNT
                </div>
                <h2 className="gpr-title">
                  Join the <span className="gpr-title-accent">experience</span>
                </h2>
                <p className="gpr-sub">
                  Create your account to track orders, redeem vouchers and access your concierge.
                </p>
              </div>

              <form className="gpr-form" onSubmit={submitForm} noValidate>
                <div className="gpr-row-2">
                  <div className="gpr-field">
                    <label htmlFor="gpr-first">First Name</label>
                    <div className="gpr-input-wrap">
                      <span className="gpr-input-icon">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z"/></svg>
                      </span>
                      <input
                        id="gpr-first"
                        type="text"
                        value={value.first_name}
                        name="first_name"
                        onChange={changeHandler}
                        disabled={loading}
                        placeholder="John"
                        autoComplete="given-name"
                      />
                    </div>
                    {validator.message("first_name", value.first_name, "required")}
                  </div>

                  <div className="gpr-field">
                    <label htmlFor="gpr-last">Last Name</label>
                    <div className="gpr-input-wrap">
                      <span className="gpr-input-icon">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z"/></svg>
                      </span>
                      <input
                        id="gpr-last"
                        type="text"
                        value={value.last_name}
                        name="last_name"
                        onChange={changeHandler}
                        disabled={loading}
                        placeholder="Doe"
                        autoComplete="family-name"
                      />
                    </div>
                    {validator.message("last_name", value.last_name, "")}
                  </div>
                </div>

                <div className="gpr-field">
                  <label htmlFor="gpr-email">Email Address</label>
                  <div className="gpr-input-wrap">
                    <span className="gpr-input-icon">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5z" /></svg>
                    </span>
                    <input
                      id="gpr-email"
                      type="email"
                      value={value.email}
                      name="email"
                      onChange={changeHandler}
                      disabled={loading}
                      placeholder="you@example.com"
                      autoComplete="email"
                    />
                  </div>
                  {validator.message("email", value.email, "required|email")}
                </div>

                <div className="gpr-field">
                  <label htmlFor="gpr-pass">New Password</label>
                  <div className="gpr-input-wrap">
                    <span className="gpr-input-icon">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </span>
                    <input
                      id="gpr-pass"
                      type={showPassword ? "text" : "password"}
                      value={value.new_password}
                      name="new_password"
                      onChange={changeHandler}
                      onBlur={changeHandler}
                      disabled={loading}
                      placeholder="At least 8 characters"
                      autoComplete="new-password"
                    />
                    <button
                      type="button"
                      className="gpr-eye-btn"
                      onClick={toggleShowPassword}
                      disabled={loading}
                      aria-label={showPassword ? "Hide password" : "Show password"}
                      tabIndex={-1}
                    >
                      {showPassword ? <CloseEye /> : <OpenEye />}
                    </button>
                  </div>
                  {validator.message("new_password", value.new_password, "required|strongPassword")}
                </div>

                <div className="gpr-field">
                  <label htmlFor="gpr-pass2">Confirm Password</label>
                  <div className="gpr-input-wrap">
                    <span className="gpr-input-icon">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </span>
                    <input
                      id="gpr-pass2"
                      type={showPassword ? "text" : "password"}
                      value={value.confirm_password}
                      name="confirm_password"
                      onChange={changeHandler}
                      disabled={loading}
                      placeholder="Re-enter password"
                      autoComplete="new-password"
                    />
                    <button
                      type="button"
                      className="gpr-eye-btn"
                      onClick={toggleShowPassword}
                      disabled={loading}
                      aria-label={showPassword ? "Hide password" : "Show password"}
                      tabIndex={-1}
                    >
                      {showPassword ? <CloseEye /> : <OpenEye />}
                    </button>
                  </div>
                  {validator.message(
                    "confirm_password",
                    value.confirm_password,
                    `required|in:${value.new_password}`,
                    {
                      messages: { in: "Passwords don't match." },
                      element: (message) =>
                        value.new_password && value.new_password === value.confirm_password ? (
                          <span className="gpr-success">Passwords match.</span>
                        ) : (
                          <span className="gpr-error">{message}</span>
                        ),
                    }
                  )}
                </div>

                <div className="gpr-row-2">
                  <div className="gpr-field">
                    <label>Gender</label>
                    <div className="gpr-radio-group">
                      <label className={`gpr-radio${value.gender === "male" ? " is-active" : ""}`}>
                        <input
                          type="radio"
                          name="gender"
                          checked={value.gender === "male"}
                          onChange={() => setValue((prev) => ({ ...prev, gender: "male" }))}
                          disabled={loading}
                        />
                        <span className="gpr-radio-dot" />
                        Male
                      </label>
                      <label className={`gpr-radio${value.gender === "female" ? " is-active" : ""}`}>
                        <input
                          type="radio"
                          name="gender"
                          checked={value.gender === "female"}
                          onChange={() => setValue((prev) => ({ ...prev, gender: "female" }))}
                          disabled={loading}
                        />
                        <span className="gpr-radio-dot" />
                        Female
                      </label>
                    </div>
                    {validator.message("gender", value.gender, "required")}
                  </div>

                  <div className="gpr-field">
                    <label htmlFor="gpr-dob">Date of Birth</label>
                    <div className="gpr-input-wrap gpr-input-wrap--date">
                      <span className="gpr-input-icon">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                          <line x1="16" y1="2" x2="16" y2="6" />
                          <line x1="8" y1="2" x2="8" y2="6" />
                          <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                      </span>
                      <DatePicker
                        id="gpr-dob"
                        showYearDropdown
                        yearDropdownItemNumber={80}
                        scrollableYearDropdown
                        placeholderText="Select date of birth"
                        selected={value.dob}
                        onChange={(date) => setValue((prev) => ({ ...prev, dob: date }))}
                        popperClassName="gpr-datepicker-popper"
                        calendarClassName="gpr-datepicker"
                        maxDate={(() => {
                          const d = new Date();
                          d.setFullYear(d.getFullYear() - 18);
                          return d;
                        })()}
                        minDate={(() => {
                          const d = new Date();
                          d.setFullYear(d.getFullYear() - 100);
                          return d;
                        })()}
                        disabled={loading}
                      />
                    </div>
                    {validator.message("dob", value.dob, "required")}
                  </div>
                </div>

                <button type="submit" className="gpr-submit" disabled={loading}>
                  {loading ? (
                    <PulseLoader size={8} color={"#0b0b0c"} />
                  ) : (
                    <>
                      Create Account
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </>
                  )}
                </button>
              </form>

              <div className="gpr-divider">
                <span>or continue with</span>
              </div>

              <button
                type="button"
                onClick={googleLogin}
                className="gpr-google"
                disabled={loading}
              >
                <GoogleIcon />
                <span>Sign up with Google</span>
              </button>

              <div className="gpr-foot">
                Already have an account?{" "}
                <Link to={loading ? "#" : "/login"} className="gpr-link-strong">
                  Sign in
                </Link>
              </div>
            </>
          )}
        </div>
      </DialogContent>

      <style>{`
        .gpr-modal .MuiBackdrop-root {
          background-color: rgba(8, 6, 2, 0.78);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
        }
        .gpr-modal .MuiDialogContent-root {
          padding: 0;
          background: transparent;
          color: inherit;
          overflow: visible;
        }

        .gpr-card {
          position: relative;
          width: 100%;
          background: linear-gradient(180deg, #15110a 0%, #1a1208 100%);
          border: 1px solid rgba(212, 168, 87, 0.25);
          border-radius: 20px;
          padding: 36px 32px 30px;
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.45);
          color: #e6e8ec;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          margin: 0 auto;
        }

        .gpr-close {
          position: absolute;
          top: 14px;
          right: 14px;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.4);
          border: 1px solid rgba(212, 168, 87, 0.25);
          color: #c5c8cf;
          display: inline-flex; align-items: center; justify-content: center;
          cursor: pointer;
          transition: background .2s ease, color .2s ease, transform .25s ease, border-color .2s ease;
          padding: 0;
          z-index: 5;
        }
        .gpr-close:hover {
          color: #d4a857;
          background: rgba(212, 168, 87, 0.12);
          border-color: rgba(212, 168, 87, 0.5);
          transform: rotate(90deg);
        }
        .gpr-close:disabled { opacity: 0.5; cursor: not-allowed; }

        /* HEAD */
        .gpr-head { text-align: center; margin-bottom: 24px; padding-right: 32px; padding-left: 32px; }
        .gpr-eyebrow {
          display: inline-flex; align-items: center; gap: 8px;
          padding: 5px 12px;
          background: rgba(212, 168, 87, 0.1);
          border: 1px solid rgba(212, 168, 87, 0.3);
          color: #d4a857;
          border-radius: 999px;
          font-size: 10.5px;
          font-weight: 700;
          letter-spacing: 1.8px;
          margin-bottom: 12px;
        }
        .gpr-eyebrow-dot {
          width: 5px; height: 5px;
          border-radius: 50%;
          background: #d4a857;
          box-shadow: 0 0 8px #d4a857;
          animation: gpr-pulse 1.6s ease-in-out infinite;
        }
        @keyframes gpr-pulse { 0%,100% { opacity:1; transform: scale(1); } 50% { opacity:.55; transform: scale(.85); } }
        .gpr-title {
          font-family: "Playfair Display", "Times New Roman", serif;
          font-size: 26px;
          font-weight: 700;
          color: #fff;
          margin: 0 0 8px;
          line-height: 1.25;
        }
        .gpr-title-accent {
          background: linear-gradient(135deg, #f1cf85, #b58a3f);
          -webkit-background-clip: text; background-clip: text; color: transparent;
          font-style: italic; font-weight: 600;
        }
        .gpr-sub {
          font-size: 13px;
          color: #9aa0a8;
          line-height: 1.55;
          margin: 0;
        }
        .gpr-sub strong { color: #d4a857; font-weight: 600; }

        /* FORM */
        .gpr-form { display: flex; flex-direction: column; gap: 14px; margin-bottom: 16px; }
        .gpr-row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
        @media (max-width: 575px) { .gpr-row-2 { grid-template-columns: 1fr; } }

        .gpr-field { display: flex; flex-direction: column; gap: 6px; }
        .gpr-field > label {
          font-size: 11px;
          color: #9aa0a8;
          font-weight: 700;
          letter-spacing: 1.2px;
          text-transform: uppercase;
        }
        .gpr-input-wrap { position: relative; display: flex; align-items: center; }
        .gpr-input-icon {
          position: absolute;
          left: 14px; top: 50%;
          transform: translateY(-50%);
          color: #d4a857;
          opacity: 0.7;
          pointer-events: none;
          z-index: 2;
        }
        .gpr-input-wrap input {
          width: 100%;
          background: rgba(0, 0, 0, 0.35);
          border: 1px solid rgba(212, 168, 87, 0.22);
          border-radius: 10px;
          color: #fff;
          font-size: 14px;
          padding: 13px 44px 13px 38px;
          outline: none;
          font-family: inherit;
          transition: border-color .2s ease, background .2s ease;
          height: 46px;
          box-sizing: border-box;
        }
        .gpr-input-wrap input::placeholder { color: #6e7480; }
        .gpr-input-wrap input:focus {
          border-color: rgba(212, 168, 87, 0.6);
          background: rgba(0, 0, 0, 0.5);
        }
        .gpr-input-wrap input:disabled { opacity: 0.6; cursor: not-allowed; }
        .gpr-input-wrap input:-webkit-autofill,
        .gpr-input-wrap input:-webkit-autofill:hover,
        .gpr-input-wrap input:-webkit-autofill:focus {
          -webkit-text-fill-color: #fff;
          -webkit-box-shadow: 0 0 0 1000px #15110a inset;
          caret-color: #fff;
        }

        .gpr-input-wrap--date { width: 100%; }
        .gpr-input-wrap--date .react-datepicker-wrapper { width: 100%; }

        .gpr-eye-btn {
          position: absolute;
          right: 8px; top: 50%;
          transform: translateY(-50%);
          background: transparent;
          border: none;
          color: #9aa0a8;
          width: 32px; height: 32px;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          border-radius: 6px;
          font-family: inherit;
          z-index: 2;
        }
        .gpr-eye-btn:hover { color: #d4a857; background: rgba(212, 168, 87, 0.08); }
        .gpr-eye-btn:disabled { opacity: 0.5; cursor: not-allowed; }
        .gpr-eye-btn svg { width: 16px; height: 16px; fill: currentColor; }

        .gpr-error {
          display: block;
          color: #ff7a7a;
          font-size: 12px;
          font-weight: 600;
          margin-top: 2px;
        }
        .gpr-success {
          display: block;
          color: #6dd58c;
          font-size: 12px;
          font-weight: 600;
          margin-top: 2px;
        }

        /* RADIO PILLS */
        .gpr-radio-group { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 2px; }
        .gpr-radio {
          display: inline-flex; align-items: center; gap: 8px;
          padding: 11px 12px;
          background: rgba(0, 0, 0, 0.35);
          border: 1px solid rgba(212, 168, 87, 0.22);
          border-radius: 10px;
          color: #c5c8cf;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          user-select: none;
          transition: background .2s ease, border-color .2s ease, color .2s ease;
        }
        .gpr-radio input { position: absolute; opacity: 0; pointer-events: none; }
        .gpr-radio-dot {
          width: 16px; height: 16px;
          border-radius: 50%;
          border: 1.5px solid rgba(212, 168, 87, 0.4);
          background: rgba(0, 0, 0, 0.5);
          flex-shrink: 0;
          position: relative;
          transition: border-color .2s ease, background .2s ease;
        }
        .gpr-radio.is-active {
          border-color: rgba(212, 168, 87, 0.6);
          background: rgba(212, 168, 87, 0.08);
          color: #fff;
        }
        .gpr-radio.is-active .gpr-radio-dot {
          border-color: #d4a857;
          background: linear-gradient(135deg, #f1cf85, #b58a3f);
        }
        .gpr-radio.is-active .gpr-radio-dot::after {
          content: "";
          position: absolute;
          inset: 4px;
          border-radius: 50%;
          background: #15110a;
        }

        /* SUBMIT */
        .gpr-submit {
          margin-top: 6px;
          width: 100%;
          display: inline-flex; align-items: center; justify-content: center; gap: 10px;
          padding: 14px;
          background: linear-gradient(135deg, #f1cf85, #d4a857 50%, #b58a3f);
          color: #0b0b0c;
          border: none;
          border-radius: 12px;
          font-size: 13px;
          font-weight: 800;
          letter-spacing: 0.6px;
          text-transform: uppercase;
          cursor: pointer;
          font-family: inherit;
          min-height: 50px;
          transition: transform .2s ease, box-shadow .25s ease, gap .2s ease;
        }
        .gpr-submit:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 14px 30px rgba(212, 168, 87, 0.35);
          gap: 12px;
        }
        .gpr-submit:disabled { opacity: 0.7; cursor: not-allowed; }

        /* DIVIDER */
        .gpr-divider {
          position: relative;
          text-align: center;
          margin: 22px 0 16px;
        }
        .gpr-divider::before {
          content: "";
          position: absolute;
          left: 0; right: 0; top: 50%;
          height: 1px;
          background: rgba(212, 168, 87, 0.18);
        }
        .gpr-divider span {
          position: relative;
          padding: 0 14px;
          background: linear-gradient(180deg, #15110a 0%, #1a1208 100%);
          font-size: 11px;
          font-weight: 700;
          color: #6e7480;
          letter-spacing: 1.4px;
          text-transform: uppercase;
        }

        /* GOOGLE */
        .gpr-google {
          width: 100%;
          display: inline-flex; align-items: center; justify-content: center; gap: 10px;
          padding: 13px;
          background: #fff;
          color: #1a1f2e;
          border: 1px solid rgba(255,255,255,0.85);
          border-radius: 12px;
          font-size: 13.5px;
          font-weight: 700;
          cursor: pointer;
          font-family: inherit;
          min-height: 48px;
          transition: transform .2s ease, box-shadow .25s ease, background .2s ease;
        }
        .gpr-google:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 12px 28px rgba(255, 255, 255, 0.12);
          background: #f8f9fa;
        }
        .gpr-google:disabled { opacity: 0.7; cursor: not-allowed; }
        .gpr-google svg { width: 18px; height: 18px; }

        /* FOOT */
        .gpr-foot {
          margin-top: 22px;
          padding-top: 18px;
          border-top: 1px dashed rgba(212, 168, 87, 0.18);
          text-align: center;
          font-size: 13px;
          color: #9aa0a8;
        }
        .gpr-link-strong {
          color: #d4a857;
          font-weight: 700;
          text-decoration: none;
          transition: color .2s ease;
          background: transparent;
          border: none;
          cursor: pointer;
          font-family: inherit;
          font-size: inherit;
          padding: 0;
        }
        .gpr-link-strong:hover { color: #f1cf85; text-decoration: underline; }
        .gpr-resend:disabled { color: #6e7480; cursor: not-allowed; text-decoration: none; }

        /* DATEPICKER */
        .gpr-datepicker-popper { z-index: 1500; }
        .gpr-datepicker {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          background: #1a1208 !important;
          color: #e6e8ec !important;
          border: 1px solid rgba(212, 168, 87, 0.3) !important;
          border-radius: 12px !important;
          box-shadow: 0 18px 40px rgba(0, 0, 0, 0.6) !important;
          overflow: hidden;
        }
        .gpr-datepicker .react-datepicker__header {
          background: #15110a !important;
          border-bottom: 1px solid rgba(212, 168, 87, 0.18) !important;
          padding-top: 12px !important;
        }
        .gpr-datepicker .react-datepicker__current-month,
        .gpr-datepicker .react-datepicker-time__header,
        .gpr-datepicker .react-datepicker-year-header,
        .gpr-datepicker .react-datepicker__day-name {
          color: #e6e8ec !important;
        }
        .gpr-datepicker .react-datepicker__day,
        .gpr-datepicker .react-datepicker__time-name {
          color: #c5c8cf !important;
          border-radius: 6px !important;
        }
        .gpr-datepicker .react-datepicker__day:hover {
          background: rgba(212, 168, 87, 0.18) !important;
          color: #fff !important;
        }
        .gpr-datepicker .react-datepicker__day--selected,
        .gpr-datepicker .react-datepicker__day--keyboard-selected {
          background: linear-gradient(135deg, #f1cf85, #b58a3f) !important;
          color: #0b0b0c !important;
          font-weight: 700 !important;
        }
        .gpr-datepicker .react-datepicker__day--disabled {
          color: #4a4f5b !important;
        }
        .gpr-datepicker .react-datepicker__day--disabled:hover {
          background: transparent !important;
        }
        .gpr-datepicker .react-datepicker__navigation-icon::before {
          border-color: #d4a857 !important;
        }
        .gpr-datepicker .react-datepicker__year-dropdown,
        .gpr-datepicker .react-datepicker__month-dropdown {
          background: #15110a !important;
          border: 1px solid rgba(212, 168, 87, 0.25) !important;
          color: #e6e8ec !important;
        }
        .gpr-datepicker .react-datepicker__year-option:hover,
        .gpr-datepicker .react-datepicker__month-option:hover {
          background: rgba(212, 168, 87, 0.18) !important;
        }
        .gpr-datepicker .react-datepicker__triangle { display: none !important; }

        @media (max-width: 480px) {
          .gpr-card { padding: 28px 20px 22px; border-radius: 16px; }
          .gpr-head { padding-left: 8px; padding-right: 8px; }
          .gpr-title { font-size: 22px; }
        }
      `}</style>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  configs: state.configs,
  carts: state.cartList.cart,
});

export default connect(mapStateToProps, { updateConfigs })(Register);
